<template>
	<core-modal
		name="bulk-trash-modal"
		class="omapi-modal bulk-trash-modal"
		:click-to-close="!isBulkTrashing"
		:is-confirmation="true"
	>
		<modals-content>
			<form @submit.prevent="bulkTrash">
				<p>Are you sure you want to trash {{ bulk.length }} {{ makePlural('campaign', bulk.length) }}.</p>

				<section class="buttons">
					<core-loading-button
						ref="toFocus"
						class="bulk-trash-campaign"
						size="large"
						color="blue"
						button-type="submit"
						:loading="isBulkTrashing"
					>
						Yes, I'm Sure
					</core-loading-button>
					<core-button
						size="large"
						:disabled="isBulkTrashing"
						@click.prevent="$modal.hide('bulk-trash-modal')"
					>
						Cancel
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { trash } from '@/campaigns/mixins/trash';
import { strings } from '@/campaigns/mixins/strings';

export default {
	mixins: [trash, strings],
};
</script>
